import cn from 'bem-cn';
import './index.less';

export var divCard = cn('divCard');
export var block = divCard('block');
export var element = divCard('element');